var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCommonSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2170_2375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10083 16.5833H9.53583L12.4683 19.5125C12.6259 19.671 12.8133 19.7967 13.0197 19.8825C13.226 19.9683 13.4473 20.0125 13.6708 20.0125C13.8179 20.0123 13.9643 19.9935 14.1067 19.9567C14.3944 19.8841 14.6578 19.7369 14.8706 19.53C15.0833 19.3232 15.2377 19.0639 15.3183 18.7783L20.4908 1.1875L5.10083 16.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90594 15.4167L19.3101 0.0100098L1.73178 5.19418C1.44556 5.27557 1.18559 5.43039 0.977673 5.64327C0.769755 5.85615 0.62111 6.11969 0.546484 6.40775C0.471858 6.69581 0.473845 6.99837 0.552249 7.28543C0.630652 7.57248 0.782747 7.83405 0.993443 8.04418L3.90594 10.9542V15.4167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2170_2375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommonSend);
export default __webpack_public_path__ + "static/media/icon_common_send.40640b397b67a97494547e4f7a9813e6.svg";
export { ForwardRef as ReactComponent };